import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO_URL } from "../lib/assets";

const LINKS = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/about", label: "About", testid: "nav-about" },
  { to: "/services", label: "Services", testid: "nav-services" },
  { to: "/projects", label: "Projects", testid: "nav-projects" },
  { to: "/contact", label: "Contact", testid: "nav-contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#F5F5F0]/95 backdrop-blur-md border-b border-[#E2E2DF]"
          : "bg-[#F5F5F0]/70 backdrop-blur-sm"
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 flex items-center justify-between h-32 md:h-36">
        <Link
          to="/"
          className="flex items-center gap-3"
          data-testid="navbar-logo-link"
          onClick={() => setOpen(false)}
        >
          <img
            src={LOGO_URL}
            alt="Trust Flooring & Interiors"
            className="h-24 md:h-28 w-auto logo-invert logo-entrance"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={l.testid}
              className={({ isActive }) =>
                `nav-link font-heading text-sm tracking-wider uppercase font-medium text-[#111111] ${
                  isActive ? "active text-[#EB1D25]" : ""
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/contact"
          data-testid="navbar-cta-get-in-touch"
          className="hidden lg:inline-flex items-center bg-[#EB1D25] text-white font-heading uppercase tracking-[0.22em] text-[11px] font-semibold px-5 py-3 hover:bg-[#111111] transition-colors duration-300"
        >
          Get in Touch
        </Link>

        <button
          className="lg:hidden text-[#111111] p-2"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
          data-testid="navbar-mobile-toggle"
        >
          {open ? <X size={26} strokeWidth={1.5} /> : <Menu size={26} strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <div
          className="lg:hidden border-t border-[#E2E2DF] bg-[#F5F5F0]"
          data-testid="mobile-nav-panel"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`${l.testid}-mobile`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `font-heading uppercase tracking-widest text-sm font-medium ${
                    isActive ? "text-[#EB1D25]" : "text-[#111111]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="navbar-cta-get-in-touch-mobile"
              onClick={() => setOpen(false)}
              className="inline-flex items-center justify-center bg-[#EB1D25] text-white font-heading uppercase tracking-widest text-xs font-semibold px-7 py-4 hover:bg-[#111111] transition-colors duration-300"
            >
              Get in Touch
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
